export enum LayerSelectorViews {
    LIST = "LIST",
    GROUP = "GROUP",
    TIME = "TIME"
}
